// test46
(46 && 0);
